require('./vendors/vendors');
(function ($) {
    /*      select option
    /*----------------------------------------*/

    let select = $('.custom-select-option');

    select.niceSelect();

    select.on('change', (e) => {
        e.target.dispatchEvent(new Event('nice-select-updated', { bubbles: true }));
    });

    /*      menu dropdown arrow
    /*----------------------------------------*/

    let megaMenuItem = $('.mega-menu > li'),
        subMenuDropdown = $('.sub-menu > .dropdown'),
        sidebarMenuSubMenu = $('.sidebar-menu .sub-menu');

    function menuDropdownArrow(parentSelector, childSelector) {
        parentSelector.each(function () {
            let self = $(this);

            if (self.children().length > 1) {
                if (window.Nya.rtl) {
                    self.children(`${childSelector}`).append('<i class="fa fa-angle-left"></i>');

                    return;
                }

                self.children(`${childSelector}`).append('<i class="fa fa-angle-right"></i>');
            }
        });
    }

    menuDropdownArrow(subMenuDropdown, 'a');
    menuDropdownArrow(megaMenuItem, '.menu-item');

    /*      navigation
    /*----------------------------------------*/

    let moreCategories = $('.more-categories'),
        categoryDropdown = $('.category-dropdown'),
        categoryNavInner = $('.category-nav-inner'),
        categoryDropdownWrap = $('.category-dropdown-wrap'),
        verticalMegaMenuList = $('.vertical-megamenu > li');

    categoryNavInner.on('click', () => {
        categoryDropdownWrap.toggleClass('show');
    });

    _window.on('load resize', () => {
        let verticalMegaMenuListHeight = 0,
            homeSliderHeight = homeSlider.height(),
            categoryDropdownHeight = homeSliderHeight;

        categoryDropdown.css('height', `${categoryDropdownHeight}px`);

        verticalMegaMenuList.each(function () {
            let self = $(this);

            verticalMegaMenuListHeight += self.height();

            if (verticalMegaMenuListHeight + 78 > categoryDropdownHeight) {
                self.addClass('hide');
                moreCategories.removeClass('hide');

                return;
            }

            self.removeClass('hide');
            moreCategories.addClass('hide');
        });
    });

    /*      slider
    /*----------------------------------------*/

    let homeSlider = $('.home-slider');

    if (homeSlider.length !== 0) {
        homeSlider.slick({
            rows: 0,
            rtl: window.Nya.rtl,
            cssEase: 'ease',
            speed: Number(homeSlider.data('speed')),
            fade: !! JSON.parse(homeSlider.data('fade')),
            dots: !! JSON.parse(homeSlider.data('dots')),
            arrows: !! JSON.parse(homeSlider.data('arrows')),
            autoplay: !! JSON.parse(homeSlider.data('autoplay')),
            autoplaySpeed: Number(homeSlider.data('autoplay-speed')),
            pauseOnHover: false,
            pauseOnFocus: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        dots: false,
                    },
                },
            ],
        }).slickAnimation();
    }

    /*      tooltip
    /*----------------------------------------*/

    $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover',
        selector: '[data-toggle="tooltip"]',
    });

    /*      top brands
    /*----------------------------------------*/

    let topBrands = $('.top-brands');

    topBrands.slick({
        rows: 0,
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 7,
        slidesToScroll: 7,
        rtl: window.Nya.rtl,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6,
                },
            },
            {
                breakpoint: 1050,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                },
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                },
            },
            {
                breakpoint: 750,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
        ],
    });

    /*      browse categories
    /*----------------------------------------*/

    $('.browse-categories li').each((i, li) => {
        if ($(li).children('ul').length > 0) {
            $(li).addClass('parent');
        }
    });

    let filterCategoriesLink = $('.browse-categories li.parent > a');
    let parentUls = $('.browse-categories li.active').parentsUntil('.browse-categories', 'ul');

    if (window.Nya.rtl) {
        filterCategoriesLink.before('<i class="fa fa-angle-left"></i>');
    } else {
        filterCategoriesLink.before('<i class="fa fa-angle-right"></i>');
    }

    parentUls.show().siblings('i').addClass('open');

    $('.browse-categories li i').on('click', (e) => {
        $(e.currentTarget).toggleClass('open').siblings('ul').slideToggle(300);
    });

});
